import { createApp } from "vue"
import App from "./core/pages/App.vue"

import { loadApp } from "./server/loadApp"

const app = createApp(App)

await loadApp(app)

if (import.meta.env.DEV) {
    // AJoute un listenr des event window parent
    window.addEventListener("message", (event) => {
        if (event.data.type) {
            console.log({
                type: event.data.type,
                data: event.data,
            })
        }
    })
}
